// notifications.js — Firebase v12
import "regenerator-runtime/runtime";
import { initializeApp } from "firebase/app";

let __msgApi = null;
async function loadMessaging() {
  if (__msgApi) return __msgApi;
  __msgApi = await import("firebase/messaging");
  return __msgApi;
}

(() => {
  if (window.__FCM_INIT_LOCK__) return;
  window.__FCM_INIT_LOCK__ = true;
  try {
    if (typeof module !== "undefined" && module.hot)
      module.hot.dispose(() => { window.__FCM_INIT_LOCK__ = false; });
    if (typeof import.meta !== "undefined" && import.meta.hot)
      import.meta.hot.dispose(() => { window.__FCM_INIT_LOCK__ = false; });
  } catch (_) {}
})();

window.addEventListener("unhandledrejection", (e) => {
  const msg = String(e?.reason?.message || e?.reason || "");
  if (
    msg.includes("pushManager") ||
    msg.includes("ServiceWorker") ||
    msg.includes("Service Worker")
  ) {
    e.preventDefault();
  }
});

function ensureRegenerator() {
  return new Promise((resolve) => {
    if (typeof window === "undefined" || window.regeneratorRuntime)
      return resolve();
    try {
      const s = document.createElement("script");
      s.src = "https://cdn.jsdelivr.net/npm/regenerator-runtime@0.13.11/runtime.min.js";
      s.async = false;
      s.onload = () => resolve();
      s.onerror = () => resolve();
      document.head.appendChild(s);
    } catch (_) {
      resolve();
    }
  });
}

const firebaseConfig = {
  apiKey: "AIzaSyCDr8_YUvITXT_PneoOCifuBb-YtJYIXhE",
  authDomain: "activtravaux-75ea9.firebaseapp.com",
  projectId: "activtravaux-75ea9",
  storageBucket: "activtravaux-75ea9.firebasestorage.app",
  messagingSenderId: "23139726134",
  appId: "1:23139726134:web:0765af23273cb68dccf997",
  measurementId: "G-07P24X7ENV"
};

const VAPID_KEY = "BGYbMVuOSUHfL2tpBRk_cV2batMUsMlo7OvptpPVEzXsjeOQSLcq5SIg_QiY9pNzqOTVgoi2Ru7u2gHYyPqLXMo";

const API_UPSERT = "/api/fcm/devices/update_or_create/";
const DEVICE_KEY = "fcm_device_id";
const TOKEN_KEY  = "fcm_registration_token";

const SW_URL = "/firebase-messaging-sw.js?v=2";

const BIND_KEY_PREFIX = "fcm_bind_done_";
const BIND_TTL_MS = 7 * 24 * 60 * 60 * 1000;

function bindMarkerKey(deviceId){ return `${BIND_KEY_PREFIX}${deviceId}`; }
function isBindFresh(deviceId){
  try {
    const raw = localStorage.getItem(bindMarkerKey(deviceId));
    if (!raw) return false;
    const t = parseInt(raw, 10) || 0;
    return (Date.now() - t) < BIND_TTL_MS;
  } catch { return false; }
}
function markBind(deviceId){
  try { localStorage.setItem(bindMarkerKey(deviceId), String(Date.now())); } catch {}
}
function readCookie(name){
  const m = document.cookie.match(new RegExp("(?:^|; )"+name+"=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}
function writeCookie(name,val){
  document.cookie = `${name}=${encodeURIComponent(val)}; Path=/; Max-Age=31536000; SameSite=Lax`;
}
function isUserAuthenticated() {
  return !!document.cookie.match(/(?:^|;\s*)sessionid=/);
}
function getOrCreateDeviceId(){
  try {
    let id = localStorage.getItem(DEVICE_KEY) || readCookie(DEVICE_KEY);
    if (!id)
      id = (crypto.randomUUID ? crypto.randomUUID() : (Date.now()+"-"+Math.random()));
    localStorage.setItem(DEVICE_KEY, id);
    writeCookie(DEVICE_KEY, id);
    return id;
  } catch {
    let id = readCookie(DEVICE_KEY);
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID() : (Date.now()+"-"+Math.random())); writeCookie(DEVICE_KEY, id);
    }
    return id;
  }
}

async function ensurePermission(){
  if (!("Notification" in window)) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  // Some bots and in-app browsers stub `Notification` without the method.
  if (typeof Notification.requestPermission !== "function") return false;
  return (await Notification.requestPermission()) === "granted";
}

async function ensureServiceWorker() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window))
    return null;
  // A refused or unreachable service worker (private mode, flaky network,
  // detached document) means no push, not an error worth reporting.
  try {
    return await registerServiceWorker();
  } catch (err) {
    console.warn("[SW] registration failed:", err);
    return null;
  }
}

async function registerServiceWorker() {
  const all = await navigator.serviceWorker.getRegistrations();
  for (const reg of all) {
    const url = (reg.active && reg.active.scriptURL) || (reg.installing && reg.installing.scriptURL) || (reg.waiting && reg.waiting.scriptURL) || "";
    if (url.endsWith("/firebase-messaging-sw.js"))
      await reg.unregister();
  }

  let reg = await navigator.serviceWorker.getRegistration(SW_URL);
  if (!reg)
    reg = await navigator.serviceWorker.register(SW_URL, { scope: "/" });

  if (reg.installing) {
    const sw = reg.installing;
    await new Promise(res => {
      const onChange = () => {
        if (sw.state === 'installed' || sw.state === 'activated' || reg.active) {
          sw.removeEventListener('statechange', onChange);
          res();
        }
      };
      sw.addEventListener('statechange', onChange);
    });
  } else {
    await navigator.serviceWorker.ready;
  }
  reg = (await navigator.serviceWorker.getRegistration(SW_URL)) || reg;
  window.__fcm_sw_reg = reg;
  return reg;
}

async function getTokenWithSW(getToken, messaging, preReg) {
  const reg = preReg || await ensureServiceWorker();
  if (!reg || !reg.pushManager) {
    console.warn("pushManager indisponible");
    return null;
  }
  return await getToken(messaging, {
    vapidKey: VAPID_KEY,
    serviceWorkerRegistration: reg,
  });
}

function getCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

async function upsertToken(currentToken){
  if (!currentToken) return;

  const deviceId = getOrCreateDeviceId();
  const last = localStorage.getItem(TOKEN_KEY);

  let needBind = !isBindFresh(deviceId);

  if (!needBind && isUserAuthenticated()) {
    try {
      const resp = await fetch(`/api/fcm/devices/?device_id=${encodeURIComponent(deviceId)}&limit=1`, {
        credentials: "include",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      });
      if (resp.ok) {
        const payload = await resp.json().catch(() => null);
        if (payload && typeof payload.count === "number" && payload.count === 0) {
          needBind = true;
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  // Si le token a changé -> POST. Si token identique mais bind nécessaire -> POST aussi.
  if (last === currentToken && !needBind) return;

  const body = new URLSearchParams({
    registration_id: currentToken,
    device_id: deviceId,
    type: "web",
    name: navigator.userAgent,
  });

  try {
    const res = await fetch(API_UPSERT, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRFToken": getCookie("csrftoken") || "",
      },
      body,
      credentials: "include",
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      console.error("FCM upsert failed", res.status, txt);
      return;
    }

    localStorage.setItem(TOKEN_KEY, currentToken);
    markBind(deviceId);
  } catch (e) {
    console.error("FCM upsert error:", e);
  }
}


const TAB_ID = (crypto.randomUUID ? crypto.randomUUID() : (Date.now()+"-"+Math.random()));
const LEADER_KEY = "fcm_leader";
const LEASE_MS = 5000;

function iAmLeader() {
  try {
    const now = Date.now();
    const raw = localStorage.getItem(LEADER_KEY);
    let cur = raw ? JSON.parse(raw) : null;
    if (!cur || (now - cur.t) > LEASE_MS) {
      localStorage.setItem(LEADER_KEY, JSON.stringify({ id: TAB_ID, t: now }));
      return true;
    }
    return cur.id === TAB_ID;
  } catch { return true; }
}

setInterval(() => {
  try {
    if (iAmLeader()) {
      localStorage.setItem(LEADER_KEY, JSON.stringify({ id: TAB_ID, t: Date.now() }));
    }
  } catch {}
}, 2000);

function wireForegroundOnce(messaging, onMessage){
  if (window.__fcm_onMessage_wired) return;
  window.__fcm_onMessage_wired = true;

  onMessage(messaging, async (payload) => {
    if (document.visibilityState === "visible" && iAmLeader()) {
      try {
        const reg = window.__fcm_sw_reg || await navigator.serviceWorker.getRegistration(SW_URL);
        if (!reg) return;

        const p = payload.notification || payload.data || {};
        const title = p.title || "Notification";
        const options = {
          body: p.body,
          icon: p.icon,
          image: p.image,
          badge: p.badge,
          tag: p.tag || "aladom-default",
          renotify: false,
          data: { click_action: p.click_action }
        };
        await reg.showNotification(title, options);
      } catch (e) {
        console.warn("foreground notify error:", e);
      }
    }
  });
}

async function cleanupRogueOnce(){
  const FLAG = "sw_cleanup_done_v2";
  if (localStorage.getItem(FLAG)) return;
  if (!("serviceWorker" in navigator)) return;

  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    for (const reg of regs) {
      const scope = reg.scope || "";
      if (scope.endsWith("/firebase-cloud-messaging-push-scope") || scope.includes("/firebase-cloud-messaging-push-scope")) {
        await reg.unregister();
      }
    }
    if ("caches" in window) {
      const keys = await caches.keys();
      for (const k of keys) await caches.delete(k);
    }
    localStorage.setItem(FLAG, "1");
  } catch(e) {
    console.warn("[SW cleanup] error:", e);
  }
}

const initFcm = async function initFcm(){
  await cleanupRogueOnce();

  const reg = await ensureServiceWorker();
  if (!reg) { console.warn("Service Worker indisponible"); return; }

  const granted = await ensurePermission();
  if (!granted) return;

  const { getMessaging, getToken, isSupported, onMessage } = await loadMessaging();
  const supported = await isSupported().catch(() => false);
  if (!supported) { console.warn("FCM Web non supporté"); return; }

  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);

  try {
    const token = await getTokenWithSW(getToken, messaging, reg);
    await upsertToken(token);
  } catch (err) {
    console.error("getToken error:", err);
  }

  wireForegroundOnce(messaging, onMessage);
};
ensureRegenerator().then(() => initFcm()).catch((err) => {
  console.warn("[FCM] init failed:", err);
});
